import { useRanger, Ranger } from "@tanstack/react-ranger";
import { useRef } from "react";
import { cx } from "shared/utils";

type Props = {
  minValue: number;
  maxValue: number;
  values: readonly number[];
  setValues: (e: readonly number[]) => void;
};

export const RangeSlider = ({
  values,
  minValue,
  maxValue,
  setValues
}: Props) => {
  const rangerRef = useRef<HTMLDivElement>(null);

  const rangerInstance = useRanger<HTMLDivElement>({
    getRangerElement: () => rangerRef.current,
    values,
    min: minValue || 0,
    max: maxValue || 100,
    stepSize: 5,
    onChange: (instance: Ranger<HTMLDivElement>) =>
      setValues(instance.sortedValues)
  });

  return (
    <div>
      <div ref={rangerRef} className="relative h-2 bg-primary-50">
        {rangerInstance.getSteps().map(({ left, width }, i) => {
          if (i !== 1) return null;

          return (
            <div
              key={i}
              style={{ width: `${width}%`, left: `${left}%` }}
              className={cx(`absolute h-full bg-primary-500`)}
            />
          );
        })}
        {rangerInstance
          .handles()
          .map(
            (
              { value, onKeyDownHandler, onMouseDownHandler, onTouchStart },
              i
            ) => (
              <button
                key={i}
                onKeyDown={onKeyDownHandler}
                onMouseDown={onMouseDownHandler}
                onTouchStart={onTouchStart}
                role="slider"
                aria-valuemin={rangerInstance.options.min}
                aria-valuemax={rangerInstance.options.max}
                aria-valuenow={value}
                className={`absolute top-1/2 flex h-6 w-6 -translate-x-1/2 -translate-y-1/2 rounded-full border-[3px] border-primary-500 bg-white `}
                style={{
                  left: `${rangerInstance.getPercentageForValue(value)}%`
                }}
              />
            )
          )}
      </div>
    </div>
  );
};
